import { useEffect } from 'react';
import type { StockVehicle } from 'src/motornet/types';
import { useConfiguratorState } from '../store';
import { useRestoreStore } from './restoreStore';

const applied = new Set<string>();

export const resetStockRestore = (): void => applied.clear();

export const isStockRestorePending = (): boolean => {
	const incoming = useRestoreStore.getState().incoming;
	return (
		!!incoming && incoming.vehicleType === 'stock' && !applied.has(incoming.id)
	);
};

export function useStockRestore(vehicles: StockVehicle[] | undefined): void {
	const incoming = useRestoreStore((s) => s.incoming);
	const isStock = incoming?.vehicleType === 'stock';

	useEffect(() => {
		if (!isStock) return;
		useConfiguratorState.getState().setVehicleMode('stock');
	}, [isStock]);

	useEffect(() => {
		if (!incoming || incoming.vehicleType !== 'stock') return;
		if (applied.has(incoming.id) || !vehicles) return;

		const found = vehicles.find((v) => v.id === incoming.vehicleStockId);
		if (!found) return;

		applied.add(incoming.id);
		const state = useConfiguratorState.getState();
		state.selectStockVehicle(found);
		state.confirmStockVehicle();
	}, [incoming, vehicles]);
}
